export default "__VITE_ASSET__CUmyg6Kh__"